export enum UrlParam {
  LANG = "lang",
  ID = "split_the_bill",
  ORDER_ID = "orderId",
  NAME = "name",
  IMAGE_LINK = "imageLink",
  SPLIT_ID = "splitId",
  REDIRECT_URL = "redirectUrl",
  PARTICIPANT_ID = "participantId",
  SENDER_NAME = "senderName",
}

export enum UrlParam3DS2 {
  cardholderInfo = "cardholderInfo",
  creq = "creq",
  md = "md",
  redirectUrl = "redirectUrl"
}